<mottu-notify></mottu-notify>
<ng-container *ngIf="featureFlagsLoaded">
	<router-outlet></router-outlet>
</ng-container>
